import React from 'react';
import RenderImg from '@op/components/RenderImg';
import { DefaultImg } from '@op/constants/defaultImg';
import VideoPlayIcon from '@opm/assets/svg/icon-video-play.svg';
import './PreviewThumbnails.scss';
import SvgIcon from '@home/components/SvgIcon';

interface IPreviewThumbnailsProps {
  /** 缩略图列表（兼容 CreativeTrends ITopCreative 和 UGC IUgcVideoItem 两种形状） */
  list?: any[];
  /** 最大展示数量，默认 3 */
  maxCount?: number;
  /** 点击缩略图回调 */
  onClick?: (item: any, index: number) => void;
  /** 是否显示分享图标 */
  shareIcon?: boolean;
}

/**
 * 缩略图预览组件（Table cell 用）
 *
 * 双态设计（按 Figma 4029_27957）：
 *  - 默认态：3 张缩略图叠加（margin-left: -10px），中央 1 个全局播放图标
 *  - hover 整行（`tr:hover`）：3 张独立平铺（gap: 10px），每张右上角独立播放按钮
 *
 * 状态切换通过 CSS 的 `tr:hover` 选择器驱动（无需 React state，性能最佳）
 */
export default function PreviewThumbnails({
  list = [],
  maxCount = 3,
  onClick,
  shareIcon = false,
}: IPreviewThumbnailsProps) {
  if (!list?.length) {
    return <span className="dbom-ct-preview-thumbnails__empty">-</span>;
  }
  const items = list.slice(0, maxCount);
  return (
    <div className="dbom-ct-preview-thumbnails">
      {items.map((item, index) => (
        <div
          key={item.video_url || index}
          className="dbom-ct-preview-thumbnails__item"
          onClick={(e) => {
            e.stopPropagation();
            onClick?.(item, index);
          }}
        >
          <RenderImg
            coverImage={item.preview_img || item.video_cover}
            defaultImage={DefaultImg.VIDEO}
            mode={'image'}
          />
          {/* 单张播放按钮（hover 行展开态可见） */}
          <div className="dbom-ct-preview-thumbnails__play">
            {shareIcon ? (
              <SvgIcon type="other-share-icon" className="dbom-ct-preview-thumbnails__share-icon" />
            ) : (
              <img src={VideoPlayIcon} alt="" className="dbom-ct-preview-thumbnails__icon" />
            )}
          </div>
        </div>
      ))}
      {/* 全局中央播放图标（默认叠加态可见） */}
      <div className="dbom-ct-preview-thumbnails__mask">
        {shareIcon ? (
          <SvgIcon type="other-share-icon" className="dbom-ct-preview-thumbnails__share-icon" />
        ) : (
          <img src={VideoPlayIcon} alt="" className="dbom-ct-preview-thumbnails__icon" />
        )}
      </div>
    </div>
  );
}
